export default "__VITE_ASSET__DllR1WE5__"